// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__1W2jK","actionColumn":"ReferralSources_actionColumn__1Q2SC","textButton":"ReferralSources_textButton__3WSSg"};